import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import request from '@/utils/request';
import API from '@/config/api';
import type { ApiLog } from '@/types/log.types';
import { fetchApiLogsRequest, fetchApiLogsSuccess, fetchApiLogsFailure } from './apiLogsSlice';

function* handleFetchApiLogs(action: PayloadAction<{ page: number; limit: number; search?: string; companyId?: string; dateFrom?: string; dateTo?: string; sortField?: string; sortOrder?: number }>) {
  try {
    const { page, limit, search, companyId, dateFrom, dateTo, sortField, sortOrder } = action.payload;
    const body: Record<string, unknown> = { page, limit };
    if (search) body.search = search;
    if (companyId) body.companyId = companyId;
    if (dateFrom) body.dateFrom = dateFrom;
    if (dateTo) body.dateTo = dateTo;
    if (sortField) body.sortField = sortField;
    if (sortOrder !== undefined) body.sortOrder = sortOrder;
    
    const res: { data: { data: { list: ApiLog[]; totalRecords: number } } } = yield call(request.post, API.API_LOGS, body);
    yield put(fetchApiLogsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) {
    yield put(fetchApiLogsFailure(e instanceof Error ? e.message : 'Failed'));
  }
}

export default function* apiLogsSaga() {
  yield takeLatest(fetchApiLogsRequest.type, handleFetchApiLogs);
}
